<template>
    <div>
        <div v-if = "header">
            <div class="navigation-header pr-2">
                <div class = "navigation-col-header remove-button pl-4">
                    <v-icon >mdi-trash-can-outline</v-icon>
                </div>
                <div class = "navigation-col-header elevator">
                    {{ $t('inc.unit.elevatorNo') }}
                </div>
            </div>
        </div>

        <v-hover
            v-if   = "!header"
            v-slot = "{ hover }"
        >
            <div
                v-if="unit"
                class="navigation-entry"
                :class ="border2"
            >
                <div
                    class="remove-button"
                    :class = "background(hover)"
                >
                    <a @click="onRemove">
                        <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                    </a>
                </div>
                <div
                    class  = "elevator"
                    :class = "background(hover)"
                >
                    {{ unit.fabricNo }}
                </div>
                <div
                    class  = "assessment"
                    :class = "background(hover)"
                >
                    {{ assessment && assessment.type ? assessment.type.name : '---' }}
                </div>
                <div
                    class  = "date"
                    :class = "background(hover)"
                >
                    {{ assessment ? dateAsString (assessment.dateAssessment) : '---' }}

                </div>
                <div
                    class  = "pr-2 amount"
                    :class = "background(hover)"
                >
                    {{ amount }}
                </div>
            </div>
        </v-hover>
    </div>
</template>

<script>

import PIncNavigationMixin from "@/modules/inc/steps/components/navigation/private/PIncNavigationMixin";

export default {
    name: "PIncNavigationEntryAssessmentInvoice",

    components: {
    },

    mixins: [
        PIncNavigationMixin
    ],

    computed: {
        amount () {
            return this.moneyAsString(this.entry.item_1.amount.net);
        },

        unit () {
            return this.entry.unit;
        },

        assessment () {
            return this.entry.reference;
        },
    },
}
</script>

<style scoped>

.assessment {
    width: 30%;
    text-align: left;
}

.date {
    width: 15%;
    text-align: left;
}

.amount {
    width: 30%;
    text-align: right;
}

.amount, .date, .assessment, .elevator {
    font-size: 15px;
    padding-top: 5px;
}

</style>